import React from 'react'
import { Typography, Divider } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import Assets from 'app/configs/assetConfigs'
import * as R from 'ramda'
import CommonBackground from 'app/components/CommonBackground'
import ContainerNotifyMeCard from 'app/components/ContainerNotifyMeCard'
import AuthenticateCardFooter from 'app/components/AuthenticateCardFooter'
import { useBreakpoints } from 'commons/useBreakpoints'
import { useAppName } from 'commons/usePartner'

const useStyles = makeStyles((theme) => ({
  logoImage: {
    height: '120px',
  },
  center: {
    textAlign: 'center',
  },
  linkColor: {
    color: `${theme.palette.textHighlight.main} !important`,
  },
  darkGreyText: {
    color: theme.palette.darkGrey.main,
  },
  darkGreyBlueText: {
    color: theme.palette.darkGreyBlue.main,
  },
  titleText: {
    [useBreakpoints(theme).lessThan.md]: {
      maxWidth: '270px',
    },
  },
  responsiveSize: {
    [useBreakpoints(theme).lessThan.md]: {
      maxWidth: '300px',
    },
  },
}))

const getRegisterSuccessPermissionState = () => {
  return {
    hasRegisterSuccessfully: true,
  }
}

function RegisterSuccess({ history, location }) {
  if (
    R.compose(R.isNil, R.path(['state', 'hasRegisterSuccessfully']))(location)
  ) {
    history.push('/')
  }

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const appName = useAppName()
  return (
    <CommonBackground>
      <ContainerNotifyMeCard>
        <div className="flex flex-col py-32 items-center">
          <img
            alt="App Logo"
            src={Assets.registerSuccess.headerImage}
            className={clsx(classes.logoImage, 'p-12', 'h-128')}
          />
          <div className="flex flex-col px-16 items-center">
            <Typography
              variant="h5"
              className={clsx(classes.titleText, 'text-center pt-16 py-8')}
              color="secondary"
            >
              <FormattedMessage
                id="registerSuccess.title"
                values={{
                  b: (text) => <b>{text}</b>,
                  appName,
                }}
              ></FormattedMessage>
            </Typography>
          </div>
          <Divider
            className={clsx(
              classes.responsiveSize,
              'w-full m-16 md:m-0 lg:m-0 xl:m-0 flex md:hidden lg:hidden xl:hidden',
            )}
          />
          <div className="self-center flex flex-col px-16 py-8  w-full md:w-2/3 items-center">
            {R.compose(
              R.map((line) => (
                <Typography
                  variant="h6"
                  key={line}
                  className={clsx(
                    classes.responsiveSize,
                    classes.darkGreyBlueText,
                    'text-center font-normal',
                  )}
                >
                  {line}
                </Typography>
              )),
              R.split('\n'),
            )(
              formatMessage({
                id: 'registerSuccess.header',
              }),
            )}
          </div>
          <Divider className="self-center my-0 xs:my-16 sm:my-16 md:my-16 lg:my-16 xl:my-16 hidden md:flex lg:flex xl:flex w-full md:w-2/3 xs:w-11/12 sm:w-11/12" />
          <div className="self-center px-16 py-8 hidden md:flex lg:flex xl:flex flex-col w-full md:w-2/3">
            <Typography
              variant="body1"
              className={clsx(classes.darkGreyBlueText, 'text-center')}
            >
              {formatMessage({
                id: 'registerSuccess.body',
              })}
            </Typography>
          </div>
          <div className="px-16 py-32 w-full">
            <AuthenticateCardFooter />
          </div>
        </div>
      </ContainerNotifyMeCard>
    </CommonBackground>
  )
}

export default RegisterSuccess

export { getRegisterSuccessPermissionState }
